import {collection, doc, getDoc, getDocs, query, where} from "firebase/firestore";
import {Auth, Firestore} from "../../firebase.js";

function getManagerUsersQuery(managerID, value) {
    return query(
        collection(Firestore, "users"),
        where(`managers.${managerID}`, "==", value),
    );
}

async function mapManagerUser(userDoc, managerID) {
    const userData = userDoc.data() || {};

    if (userData.deleted) {
        return null;
    }

    const rolesDoc = await getDoc(doc(Firestore, "users", userDoc.id, "billett", managerID));
    const rolesData = rolesDoc.data() || {};

    return {
        id: userDoc.id,
        ...userData,
        roles: Array.isArray(rolesData.roles) ? rolesData.roles : [],
    };
}

export function useFbGetUser() {
    return () => {
        return getDoc(doc(Firestore, "users", Auth.currentUser.uid))
            .then((res) => {
                return res.data();
            })
    };

}

export async function fbGetUsers(managerID) {
    console.log("fbGetUsers request", {
        managerID,
        source: "firestore",
    });

    try {
        const [booleanUsersSnap, stringUsersSnap] = await Promise.all([
            getDocs(getManagerUsersQuery(managerID, true)),
            getDocs(getManagerUsersQuery(managerID, "true")),
        ]);

        const uniqueUsers = new Map();

        [...booleanUsersSnap.docs, ...stringUsersSnap.docs].forEach((userDoc) => {
            uniqueUsers.set(userDoc.id, userDoc);
        });

        const users = (await Promise.all(
            Array.from(uniqueUsers.values()).map((userDoc) => mapManagerUser(userDoc, managerID)),
        )).filter(Boolean);

        console.log("fbGetUsers normalized users", {managerID, users});

        return users;
    } catch (error) {
        console.error("fbGetUsers failed", {
            managerID,
            source: "firestore",
            code: error?.code,
            message: error?.message,
            details: error?.details,
            error,
        });

        throw error;
    }
}
